import { ref } from 'vue';
import useEnvParams from '@composables/useEnvParams';
import useExperimentIds from '@composables/useExperimentIds'; // SSR experiments
import useKillSwitches from '@composables/useKillSwitches';

/**
 * useThumbnailEligibility
 * @returns
 */
export default function useThumbnailEligibility() {
  const { experimentIds } = useExperimentIds();
  const { priceSimplificationEnabled, macysExclusiveEnabled } = useKillSwitches();
  const { isBcom, isMcom } = useEnvParams();

  // turn on price simplification
  const isSimplificationOn = ref(!!isMcom);

  // color swatch experiment
  const colorSwatchEnhancement = ref(((experimentIds.value.includes('2483-21') || experimentIds.value.includes('2483-22')) && isMcom)
  || (experimentIds.value.includes('2483-22') && isBcom));

  const bcomSmallSwatches = ref(isBcom);

  // macys exclusive badging exp
  const macysExclusiveBadging = ref(experimentIds.value.includes('2545-21') && macysExclusiveEnabled);

  // price simplification new experiment flags
  const simplificationWithV1 = ref(false); // Flag is used by bcom 2054-22 experiment Q4'25
  const simplificationNonBoldPercentageExp = ref(!!isMcom);
  const simplificationRemoveSaleExp = ref(false);

  const simplificationExpIds = ['2054-21'];
  const simplificationBcomIds = ['2054-22'];
  const hasSimplificationExp = experimentIds.value.some((id) => simplificationExpIds.includes(id));
  const hasBcomSimplificationExp = experimentIds.value.some((id) => simplificationBcomIds.includes(id));
  /* istanbul ignore else */
  if (isBcom) {
    simplificationWithV1.value = hasBcomSimplificationExp && priceSimplificationEnabled;
    // For Bcom, isSimplificationOn is true when
    // hasSimplificationExp(2054-21) OR hasBcomSimplificationExp(2054-22) = true
    // and KS priceSimplificationEnabled is true
    isSimplificationOn.value = (hasSimplificationExp || hasBcomSimplificationExp) && priceSimplificationEnabled;
  }

  const disablePzoBadges = ref(experimentIds.value.includes('2563-21'));

  const useAppliedMcomCopyExp = ref((experimentIds.value.includes('2542-21') || experimentIds.value.includes('2542-22')) && isMcom);

  const priceTypeBadgeExp = ref(experimentIds.value.includes('2634-21') && isMcom);

  const mcomFontWeight = ref(isMcom);

  return {
    colorSwatchEnhancement,
    isSimplificationOn,
    simplificationWithV1,
    simplificationNonBoldPercentageExp,
    simplificationRemoveSaleExp,
    disablePzoBadges,
    macysExclusiveBadging,
    bcomSmallSwatches,
    useAppliedMcomCopyExp,
    priceTypeBadgeExp,
    mcomFontWeight,
  };
}
